'use client';

import useCoreConfig from '@/hooks/use-core-config';
import AppBar from '../app-bar/app-bar';
import CenteredAppBar from '../centered-app-bar/centered-app-bar';
import SecondaryAppBar from '../secondary-app-bar/secondary-app-bar';

const HeaderChrome = () => {
  const {
    variants: { navigation },
  } = useCoreConfig();

  switch (navigation) {
    case 'BLACK_APP_BAR':
      return <SecondaryAppBar />;
    case 'CENTERED_APP_BAR':
      return <CenteredAppBar />;
    default:
      return <AppBar />;
  }
};

export default HeaderChrome;
